import React from 'react';

import Skeleton from '../skeleton';

import './module-info.scss';

interface ModuleInfoProps {
  topPrefix: string | number;
  topPostfix?: string;
  bottomDesc: string;
  loading?: boolean;
  widthSkeleton?: number;
  heightSkeleton?: number;
}

const ModuleInfo: React.FC<ModuleInfoProps> = ({
  topPostfix,
  topPrefix,
  bottomDesc,
  loading,
  widthSkeleton,
  heightSkeleton,
}) =>
  loading ? (
    <Skeleton
      className="module-info"
      variant="rect"
      width={widthSkeleton}
      height={heightSkeleton}
    />
  ) : (
    <div className="module-info">
      <div className="module-info__top">
        {topPrefix}
        {topPostfix && <span>{topPostfix}</span>}
      </div>
      <div className="module-info__bottom">{bottomDesc}</div>
    </div>
  );

export default ModuleInfo;
